import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { verticalSpace } from '@doltech/utils/lib/css-style';

const Container = styled.div`
  ${verticalSpace(8)}
`;

export const MultipleChoiceOptions = (props: RenderElementProps) => {
  const { children, attributes } = props;

  return (
    <Container className="multiple-choice-options" contentEditable={false} {...attributes}>
      {children}
    </Container>
  );
};
